import React, { useEffect, useRef, useState } from "react";
import { Form } from "react-router-dom";
import axios from "../../API/axios";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import WarningAmberSharpIcon from "@mui/icons-material/WarningAmberSharp";
import moment from "moment";
import CreatableSelect from "react-select/creatable";
import { debounce, set } from "lodash";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import { customStyles, wljSelectPortalProps } from "../../selectStyles";
import { findSelectOption, seedSelectOptions } from "../../utility/selectFieldHelpers";
import Flatpickr from 'react-flatpickr';
import { resume } from "../../config/imagesLink";
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import { Button, Overlay, Popover } from "react-bootstrap";
import { Input } from "reactstrap";
import DeleteOutlineSharpIcon from '@mui/icons-material/DeleteOutlineSharp';
import { useTranslation } from "react-i18next";
import useEscapeKeyDown from "../../hooks/useEscapeKeyDown";
import { Portal } from "../../components/Portal";



const ProfileExperienceUpdate = ({
  showExperienceUpdate,
  handleUpdateExperienceClose,
  getUserProfile,
  ExperienceData,
}) => {
  const { t } = useTranslation();
  useEscapeKeyDown(showExperienceUpdate, handleUpdateExperienceClose);

  const sessionId = localStorage.getItem("sessionId");
  const UserCcv = localStorage.getItem("UserCcv");

  const [startDate, setStartDate] = useState(null);
  const [present, setPresent] = useState(false);
  const [endDate, setEndDate] = useState(null);
  const isExperienceDateRangeInvalid =
    Boolean(startDate) &&
    Boolean(endDate) &&
    moment(endDate).isBefore(moment(startDate), "day");
  const [cityData, setCityData] = useState([]);
  const [cityId, setCityId] = useState(null);
  const [citySearch, setCitySearch] = useState(null);

  const [display, setDisplay] = useState(false);
  // console.log("ExperienceData1", ExperienceData);
  const [description, setDescription] = useState("");
  const [showInputInsteadOfDropdown, setShowInputInsteadOfDropdown] = useState(false);


  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);

  const [value, setValue] = useState(null);
  const [pageD, setPageD] = useState(0);
  const [typed, setTyped] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const [totalPagesDesignation, setTotalPagesDesignation] = useState(0);
  const language = localStorage.getItem("Lang");
  const [pageC, setPageC] = useState(0);
  const [typeC, setTypeC] = useState("");
  const [valueC, setValueC] = useState(null);
  const [isLoadingC, setIsLoadingC] = useState(false);
  const [optionsC, setOptionsC] = useState([]);
  const [totalPagesCom, setTotalPagesCom] = useState(0);
  console.log('typeC', typeC, valueC);

  const logValue = debounce((typed) => {
    setTyped(typed);
  }, 250);

  const logValueC = debounce((typeC) => {
    setTypeC(typeC);
  }, 250);
  console.log('endDate', endDate);
  const [getOrgInsTId, setGenOrgInstId] = useState('');
  const [newOrgType, setnewOrgType] = useState(null);

  const UpdateExperience = async () => {
    setDisplay(true);
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      userExpId: ExperienceData?.userExpId,
      startDate: startDate === "" ? "" : moment(startDate).format("YYYY-MM-DD"),
      // endDate: endDate === "" || endDate === null ? "" : moment(endDate).format("YYYY-MM-DD"),
      endDate: present ? null : moment(endDate).format("YYYY-MM-DD"),
      isPresent: present,
      jobTitle: value,
      companyUid: valueC === null ? JSON.stringify(getOrgInsTId) : valueC,
      description: description,
      locationId: null,
      cityId: cityId,
      positionHeadline: headline,
      jobType: jobTypeId,
      workLocationType: workLocationId,
      workLevelType: workTypeId,
      langKey: language === "en" ? "" : language,
      isSynced: sync
    };
    console.log("UpdateExperience", data);
    if (
      // valueC === null ||
      value === null ||
      jobTypeId === null ||
      workLocationId === null ||
      workTypeId === null ||
      cityId === null ||
      !startDate ||
      (!present && !endDate)
    ) {
      setErrorToastMessage(t("modals.Please fill all the required fields"));
      setShowErrorToast(true);
    } else if (!present && isExperienceDateRangeInvalid) {
      setErrorToastMessage("End date cannot be earlier than start date.");
      setShowErrorToast(true);
    } else {
      try {
        await axios
          .put(`UserData/UpdateWorkExperienceInfo`, data)
          .then((resData) => {
            console.log("resData exp", resData.data.responseData);
            getUserProfile();
            setToastMessage(resData.data.message);
            setShowToast(true);
            handleUpdateExperienceClose();
          });
      } catch (error) {
        if (error.response && error.response.status === 404) {
          setWarningToastMessage(error.response.data.message);
          setShowWarningToast(true);
        } else {
          setErrorToastMessage(error.response.data.message);
          setShowErrorToast(true);
        }
      }
    }

  };
  useEffect(() => {
    if (
      startDate &&
      endDate &&
      moment(endDate).isBefore(moment(startDate), "day")
    ) {
      setEndDate(null);
    }
  }, [startDate, endDate]);

  //************************profile headline Start  ************************//
  // const [headline, setHeadline] = useState(null);
  const [headline, setHeadline] = useState("");

  const [pageP, setPageP] = useState(0);
  const [typedprofile, setTypedprofile] = useState("");
  const [optionsP, setOptionsP] = useState([]);
  const [totalPagesProfile, setTotalPagesProfile] = useState(0);

  const logValue1 = debounce((typedprofile) => {
    setTypedprofile(typedprofile);
  }, 250);

  const addOptionsprofile = () => {
    setIsLoading(true);
    const data = {
      pageNumber: pageP + 1,
      pageSize: 100,
      deviceType: "Web",
    }
    axios
      .post(
        `Master/GetPositionHeadlineDDL?search=${typedprofile}&LangKey=${language}`, data
      )
      .then((response) => {
        console.log("response.........", response);
        const data = response?.data?.responseData?.allData;
        // Check if data is an array
        if (Array.isArray(data)) {
          const mappedData = data.map((item, index) => ({
            label: item,
            value: item,
          }));
          console.log("mappedData==>", mappedData)
          setOptionsP((prevOptions) => [...prevOptions, ...mappedData]);
        } else {
          console.error("Expected data to be an array, but got:", data);
        }

        setPageP((prevPage) => prevPage + 1);
        setIsLoading(false);
        setTotalPagesProfile(response?.data?.paging?.totalPages || 0);
      })
      .catch((error) => {
        console.error("Error fetching options:", error);
        setIsLoading(false);
      });
  };
  const handleOpenProfle = () => {
    setPageP(1);
  };

  const handleChangeProfile = (value) => {
    if (value === null) {
      setHeadline(null);
    } else {
      setHeadline(value.label);
    }
  };

  const handleInputChangeProfile = (typedprofile) => {
    logValue1(typedprofile);
    if (!typedprofile) setPageP(0);
  };

  const handleMenuScrollToBottomProfile = () => {
    if (pageP < totalPagesProfile) {
      addOptionsprofile();
    }
  };

  useEffect(() => {
    if (typedprofile) {
      addOptionsprofile();
    }
  }, [typedprofile]);

  //************************ profile headline End  ************************//


  const addOptions = () => {
    setIsLoading(true);
    axios
      .get(
        `Master/GetDesignationDDL?DeviceType=Web&search=${typed}&pageNumber=${pageD + 1
        }&pageSize=100&LangKey=${language}`
      )
      .then((response) => {
        const data = response?.data?.responseData?.data;
        if (Array.isArray(data)) {
          const mappedData = data.map((item) => ({
            value: item.dsgntnId,
            label: item.name,
          }));

          setOptions((prevOptions) => [...prevOptions, ...mappedData]);
        } else {
          console.error("Expected data to be an array, but got:", data);
        }
        setPageD((prevPage) => prevPage + 1);
        setIsLoading(false);
        // setOptions((prevOptions) => [...prevOptions, ...data]);
        setTotalPagesDesignation(response.data.paging.totalPages);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const handleOpen = () => {
    setPageD(1);
  };
  // const handleChange = (value) => {
  //   if (value === null) {
  //     setValue(null);
  //   } else {
  //     setValue(value.label);
  //   }
  // };

  const handleInputChange = (typed) => {
    logValue(typed);
    if (!typed) setPageD(0);
  };

  const handleMenuScrollToBottom = () => {
    if (pageD < totalPagesDesignation) {
      addOptions();
    }
  };

  const handleOpenC = () => {
    setPageC(1);
  };

  const handleChangeC = (value) => {
    if (value === null) {
      setValueC(null);
    } else {
      setValueC(value.value);
    }

    setPageC(0);
  };

  const handleInputChangeC = (typed) => {
    logValueC(typed);
    if (!typed) setPageC(0);
  };

  const handleMenuScrollToBottomC = () => {
    if (pageC < totalPagesCom) {
      Companies();
    }
  };

  const Companies = () => {
    setIsLoadingC(true);
    axios
      .get(
        `Master/GetAllCompaniesDDL?search=${typeC}&pageNumber=${pageC + 1
        }&pageSize=100&DeviceType=Web&LangKey=${language}`
      )
      .then((response) => {
        console.log(response);
        const data = response?.data?.responseData?.list.map((item) => ({
          value: item.uiDno,
          label: item.name,
          isOrgVrfd: item.isVerified,
          isOrgRgd: item.isRgstrd,
        }));
        setPageC((prevPage) => prevPage + 1);
        setIsLoadingC(false);
        setOptionsC((prevOptions) => [...prevOptions, ...data]);
        setTotalPagesCom(response.data.responseData.paging.totalPages);
      })
      .catch((error) => {
        console.log(error);
        setIsLoadingC(false);
      });
  };

  useEffect(() => {
    if (typeC) {
      Companies();
    }
  }, [typeC]);

  console.log("optionsC", optionsC);
  const renderOption = ({
    focusedOption,
    focusOption,
    key,
    labelKey,
    option,
    selectValue,
    style,
    valueArray,
  }) => {
    // Your rendering logic here
  };

  const renderOptionC = ({
    focusedOption,
    focusOption,
    key,
    labelKey,
    option,
    selectValue,
    style,
    valueArray,
  }) => {
    // Your rendering logic here
  };

  useEffect(() => {
    if (typed) {
      addOptions();
    }
  }, [typed]);

  const getCity = () => {
    axios
      .get(`Master/GetCitiesDDL?search=${citySearch}&LangKey=${language}`)
      .then((response) => {
        const res = response.data.responseData;
        const data = res.map((item) => ({
          value: item.cityId,
          label: item.cityName,
        }));
        setCityData(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    if (citySearch) {
      getCity();
    }
  }, [citySearch]);
  console.log("optionsC", optionsC);

  //********Job Type List Start  ********//
  const [jobTypeData, setJobTypeData] = useState([]);
  const [jobTypeId, setJobTypeId] = useState(null);
  const getJobType = () => {
    axios
      .get(`Master/GetJobTypesDDL?LangKey=${language}`)
      .then((response) => {
        const res = response.data.responseData;
        const data = res.map((item) => ({
          value: item.id,
          label: item.name,
        }));
        setJobTypeData(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    getJobType();
  }, []);
  //********Job Type List End  ********//

  //********Work Level Type List Start  ********//
  const [workTypeData, setWorkTypeData] = useState([]);
  const [workTypeId, setWorkTypeId] = useState(null);
  const getWorkType = () => {
    axios
      .get(`Master/GetWorkLevelTypesDDL?LangKey=${language}`)
      .then((response) => {
        const res = response.data.responseData;
        const data = res.map((item) => ({ value: item.id, label: item.name }));
        setWorkTypeData(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    getWorkType();
  }, []);
  //********Work Level Type List End  ********//

  //********Work Location Type List Start  ********//
  const [workLocationData, setWorkLocationData] = useState([]);
  const [workLocationId, setWorkLocationId] = useState(null);
  const getWorkLocationType = () => {
    axios
      .get(`Master/GetWorkLocationTypesDDL?LangKey=${language}`)
      .then((response) => {
        const res = response.data.responseData;
        const data = res.map((item) => ({ value: item.id, label: item.name }));
        setWorkLocationData(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    getWorkLocationType();
  }, []);
  //********Work Location Type List End  ********//

  // useEffect(() => {
  //   if (showExperienceUpdate) {
  //     document.body.style.overflow = 'hidden';
  //     document.documentElement.style.overflow = 'hidden';
  //     document.body.classList.add('modal-open'); // When a modal opens
  //   } else {
  //     document.body.style.overflow = 'unset';
  //     document.documentElement.style.overflow = '';
  //     document.body.classList.remove('modal-open'); // When a modal closes
  //   }
  // }, [showExperienceUpdate]);

  useEffect(() => {
    if (ExperienceData) {
      setShowInputInsteadOfDropdown(true);
      setValue(ExperienceData?.jobTitle);
      setTyped(ExperienceData?.jobTitle);
      setValueC(ExperienceData?.companyUid);
      setTypeC(ExperienceData?.companyName);
      setHeadline(ExperienceData?.positionHeadline);
      setJobTypeId(ExperienceData?.jobType);
      setWorkTypeId(ExperienceData?.workLevelType);
      setWorkLocationId(ExperienceData?.workLocationType);
      setCityId(ExperienceData?.cityId);
      setCitySearch(ExperienceData?.cityName);
      setDescription(ExperienceData?.description);
      setStartDate(ExperienceData?.startDate || null);
      setEndDate(ExperienceData?.endDate || null);
      setPresent(ExperienceData?.isPresent);
      setPageC(0)
      setPageD(0)
      if (ExperienceData?.companyUid && ExperienceData?.companyName) {
        setOptionsC(seedSelectOptions(ExperienceData.companyUid, ExperienceData.companyName));
      }
      if (ExperienceData?.cityId && ExperienceData?.cityName) {
        setCityData(seedSelectOptions(ExperienceData.cityId, ExperienceData.cityName));
      }
    }
  }, [ExperienceData]);
  console.log("ProfileHeadline===>", headline)
  const preventYearScroll = (datePickerInstance) => {
    const yearElement = datePickerInstance.currentYearElement;
    if (yearElement) {
      yearElement.addEventListener("wheel", (e) => {
        e.preventDefault(); // Stops mouse scroll
      });
    }
  };
  const [sync, setSync] = useState(false);

  const [checkCurrent, setCheckCurrent] = useState('')
  console.log('checkCurrent', checkCurrent);

  const CheckCurrentExperienceStatus = async (Id) => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      langKey: language === "en" ? "" : language,
    };
    try {
      await axios
        .post(`ResumeData/CheckCurrentRsmExperienceStatus`, responseData)
        .then((res) => {
          setCheckCurrent(res?.data?.responseData)
        });
    } catch (error) {
      console.log(error.response.data.message);
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  useEffect(() => {
    if (showExperienceUpdate) {
      CheckCurrentExperienceStatus()
    }
  }, [])

  const [showTooltip, setShowTooltip] = useState(false);
  const [OrganizationName, setOrganizationName] = useState("");
  const [InsName, setInsName] = useState("");
  const targetRef = useRef(null);
  const toggleTooltip = () => {
    console.log("Toggling Tooltip");
    setShowTooltip((prev) => !prev);
  };

  const handleCloseNewOrg = (e) => {
    e?.preventDefault?.();
    setInsName("");
    setOrganizationName("");
    setGenOrgInstId("");
    setnewOrgType(null);
    setValueC(null);
    setFileName("");
  };

  const [fileName, setFileName] = useState(""); // State to store selected filename
  const handleFileChange = (event) => {
    const file = event.target.files[0]; // Get the selected file
    if (file) {
      setFileName(file.name); // Set the filename in state
    }
  };



  const [orgCity, setOrgCity] = useState(null);
  const handleSaveInstitution = async () => {
    // setDisplay(true);

    // const formData = new FormData();
    // formData.append("orgName", OrganizationName);
    // formData.append("OrgType", "UnRegdInstitution");
    // formData.append("CityID", orgCity);
    // formData.append("OrgLogo", fileName);
    // formData.append("sessionId", sessionId);
    // console.log("formData", formData);

    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      gnrlOrgName: OrganizationName,
      type: 1,
      cityId: cityId,
      logoImage: fileName,
      locationId: null,
      langKey: language === "en" ? "" : language,
    }

    try {
      const res = await axios.post("/General/AddGeneralOrgByUser", data);
      console.log("resposne new", res);
      setGenOrgInstId(res.data.responseData.id);
      setnewOrgType(res.data.responseData.value);
      setInsName(res.data.responseData.value);
      // toast.success(res.data.message);
      setShowTooltip(false);
      setOrganizationName("");
      setOrgCity(null);
      setFileName("");
    } catch (error) {
      if (error.response && error.response.status === 404) {
        // toast.warning(error.response.data.message);
      } else {
        // toast.error(error.response?.data?.message || "An error occurred");
      }
    }
  };

  // //************************Enable Experience  ************************//
  // const [status, setStatus] = useState('')
  // const EnableExperience = async (Id) => {
  //   const responseData = {
  //     deviceType: "Web",
  //     sessionId: sessionId,
  //     id: Id,
  //   };
  //   try {
  //     await axios
  //       .put(`UserData/EnableWorkExperienceInfo`, responseData)
  //       .then((res) => {
  //         setToastMessage(res.data.message);
  //         setShowToast(true);
  //         // getUserProfile();
  //         setStatus(1)
  //       });
  //   } catch (error) {
  //     console.log(error.response.data.message);
  //     if (error.response && error.response.status === 404) {
  //       setWarningToastMessage(error.response.data.message);
  //       setShowWarningToast(true);
  //     } else {
  //       setErrorToastMessage(error.response.data.message);
  //       setShowErrorToast(true);
  //     }
  //   }
  // };
  // //************************Enable Experience End  ************************//
  // //************************Disable Experience  ************************//
  // const DisableExperience = async (Id) => {
  //   const responseData = {
  //     deviceType: "Web",
  //     sessionId: sessionId,
  //     id: Id,
  //   };
  //   try {
  //     await axios
  //       .put(`UserData/DisableWorkExperienceInfo`, responseData)
  //       .then((res) => {
  //         setToastMessage(res.data.message);
  //         setShowToast(true);
  //         // getUserProfile();
  //         setStatus(0)
  //       });
  //   } catch (error) {
  //     console.log(error.response.data.message);
  //     if (error.response && error.response.status === 404) {
  //       setWarningToastMessage(error.response.data.message);
  //       setShowWarningToast(true);
  //     } else {
  //       setErrorToastMessage(error.response.data.message);
  //       setShowErrorToast(true);
  //     }
  //   }
  // };
  // //************************Disable Experience End  ************************//

  //************************Remove Experience Start  ************************//

  // const [showExperienceDelete, setShowExperienceDelete] = useState(false);
  // const handleRemoveExperienceClose = () => {
  //   setShowExperienceDelete(false);
  // };

  // const [ExperienceId, setExperienceId] = useState("");

  // const removeExperience = async () => {
  //   const responseData = {
  //     deviceType: "Web",
  //     sessionId: sessionId,
  //     id: ExperienceId,
  //     // skllId: skillId
  //   };
  //   try {
  //     await axios
  //       .delete(`UserData/DeleteWorkExperienceInfo`, { data: responseData })
  //       .then((res) => {
  //         setShowExperienceDelete(!showExperienceDelete);
  //         // toast.success(res.data.message);
  //         setToastMessage(res.data.message);
  //         setShowToast(true);
  //         getUserProfile();
  //       });
  //   } catch (error) {
  //     if (error.response && error.response.status === 404) {
  //       setWarningToastMessage(error.response.data.message);
  //       setShowWarningToast(true);
  //     } else {
  //       setErrorToastMessage(error.response.data.message);
  //       setShowErrorToast(true);
  //     }
  //   }
  // };
  // console.log("ExperienceData8888888", ExperienceData);

  //************************Remove Experience End  ************************//


  //   useEffect(() => {
  //   let scrollY = 0;

  //   if (showExperienceUpdate) {
  //     scrollY = window.scrollY;

  //     // Lock scroll
  //     document.body.style.position = 'fixed';
  //     document.body.style.top = `-${scrollY}px`;
  //     document.body.style.left = '0';
  //     document.body.style.right = '0';
  //     document.body.style.overflow = 'hidden';
  //     document.documentElement.style.overflow = 'hidden'; // 🛠️ Add this line
  //     document.body.classList.add('modal-open');
  //   } else {
  //     // Unlock scroll
  //     const scrollYValue = document.body.style.top;
  //     document.body.style.position = '';
  //     document.body.style.top = '';
  //     document.body.style.left = '';
  //     document.body.style.right = '';
  //     document.body.style.overflow = '';
  //     document.documentElement.style.overflow = ''; // 🛠️ Add this line
  //     document.body.classList.remove('modal-open');

  //     window.scrollTo(0, parseInt(scrollYValue || '0') * -1);
  //   }
  // }, [showExperienceUpdate]);

  useEffect(() => {
    let scrollY = 0;
    if (showExperienceUpdate) {
      scrollY = window.scrollY;
      document.body.dataset.scrollY = scrollY;

      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
      document.body.classList.add('modal-open'); // When a modal opens
    } else {
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
      document.body.classList.remove('modal-open'); // When a modal closes

      const storedY = document.body.dataset.scrollY || "0";
      window.scrollTo(0, parseInt(storedY, 10));
    }
  }, [showExperienceUpdate])

  const modalContentRef = useRef(null);

  return (
    <>
      {showExperienceUpdate && (
        <div className="profile-experince-upadate">
          <Portal layer="modal">
            <div
              className="modal fade show modal-lg wlj-overlay-modal"
              tabIndex="-1"
              role="dialog"
              style={{ display: "flex" }}
            >
              <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content" ref={modalContentRef}>
                  <div className="setting-header d-flex justify-content-between align-items-center p-2">
                    <div className="d-flex align-items-center">
                      <h6 className="mb-0 me-3">
                        {t("modals.Update Experience")}
                      </h6>

                    </div>

                    <CloseSharpIcon
                      className="material-symbols-sharp me-3 pointer"
                      onClick={handleUpdateExperienceClose}
                    />
                  </div>
                  <Form>
                    {ExperienceData?.note && (
                      <p className="warningText d-flex mt-1 me-3 ms-3 ">
                        {" "}
                        <WarningAmberSharpIcon style={{ fontSize: "16px" }} />
                        {t("modals.Warning:")}
                        {ExperienceData?.note}
                      </p>
                    )}

                    <div className="row modal-p settings CreateCompany">
                      <div className="col-md-6 ">
                        <label htmlFor="about" className="wlj-edu-field-label">
                          {t("User Profile.Designation (Job Title)")}
                          <span className="text-danger ms-2">*</span>
                        </label>

                        {/* <Select
                        value={options.find((option) => option.value === value)}
                        options={options}
                        optionRenderer={renderOption}
                        placeholder= {t("modals.Search and Select Designation")}
                        onOpen={handleOpen}
                        styles={customStyles} {...wljSelectPortalProps}
                        onChange={handleChange}
                        onMenuScrollToBottom={handleMenuScrollToBottom}
                        onInputChange={handleInputChange}
                        isClearable
                      /> */}
                        {showInputInsteadOfDropdown ? (
                          <input
                            type="text"
                            className="Dark-Input-from-group"
                            value={value}
                            onChange={e => setValue(e.target.value)}
                            onBlur={() => {
                              if (value && value.trim()) setShowInputInsteadOfDropdown(false);
                            }}
                            autoFocus
                            isInvalid={display && value === ""}
                          />
                        ) : (
                          <CreatableSelect
                            options={options}
                            styles={customStyles} {...wljSelectPortalProps}
                            classNamePrefix="react-select"
                            placeholder={t("modals.Search and Select Designation")}
                            noOptionsMessage={() => t("modals.Search and Select Designation")}
                            onOpen={handleOpen}
                            onChange={selectedOption => {
                              if (!selectedOption) {
                                setValue("");
                              } else {
                                setValue(selectedOption.label);
                                if (typeof selectedOption.label === "string" && isNaN(selectedOption.label)) {
                                  setShowInputInsteadOfDropdown(true);
                                }
                              }
                            }}
                            onMenuScrollToBottom={handleMenuScrollToBottom}
                            onInputChange={handleInputChange}
                            isClearable
                            value={options.find(option => option.label === value) || (value ? { label: value, value } : null)}
                            className={display && !value ? "is-invalid" : ""}
                            isValidNewOption={(inputValue, _, selectOptions) =>
                              !!inputValue && !selectOptions.some(option => option.label === inputValue)
                            }
                            onCreateOption={inputValue => {
                              setValue(inputValue);
                              setShowInputInsteadOfDropdown(true);
                            }}
                          />
                        )}
                        {display && !value ? (
                          <span className="error_msg_lbl">
                            {t("User Profile.Please Select Designation")} {" "}
                          </span>
                        ) : null}
                      </div>

                      <div className="col-md-6 mt-2">
                        <div className="wlj-edu-label-row d-flex align-items-center">
                          <label htmlFor="about" className="mb-0">
                            {t("User Profile.Company")}
                            <span className="text-danger ms-2">*</span>
                          </label>
                          {InsName !== "" ? (
                            <a
                              href="#"
                              onClick={handleCloseNewOrg}
                              className="createModal f-14 ms-2"
                            >
                              {t("User Profile.Close")}
                            </a>
                          ) : (
                            <a
                              href="#"
                              ref={targetRef}
                              onClick={(e) => {
                                e.preventDefault();
                                toggleTooltip();
                              }}
                              className="createModal f-14 ms-2"
                            >
                              {t("User Profile.Create New")}
                            </a>
                          )}
                        </div>
                        <Overlay
                          target={targetRef.current}
                          show={showTooltip}
                          placement="bottom"
                          rootClose
                          container={document.querySelector(".modal")}
                          onHide={() => setShowTooltip(false)} // Close when clicking outside
                        >
                          <Popover id="popover-basic">
                            <Popover.Header as="h3" className="Dark-Body-Card-group">{t("Sidemenubar.Create Company")}</Popover.Header>
                            <Popover.Body className="Dark-Body-Card-group">
                              <Form>
                                <div>
                                  <label className="mb-1 Text-mb-Create">{t("Newsfeed.Company Name")}</label>
                                  <input
                                    type="text"
                                    value={OrganizationName}
                                    onChange={(e) => setOrganizationName(e.target.value)}
                                    placeholder={t("User Profile.Enter Company Name")}
                                    className="mb-2 form-control Dark-Input-from-group"
                                  />
                                </div>
                                <div>
                                  <label className="mb-1 Text-mb-Create">{t("User Profile.City")}</label>
                                  <Select
                                    defaultValue={cityId}
                                    onChange={(selectedOption) =>
                                      setCityId(selectedOption.value)
                                    }
                                    options={cityData}
                                    placeholder={t("modals.Search and Select City")}
                                    onInputChange={(inputValue) => {
                                      setCitySearch(inputValue);

                                    }}
                                    invalid={display && cityId === ""}
                                    styles={customStyles} {...wljSelectPortalProps}
                                    classNamePrefix="react-select"
                                  />
                                </div>
                                <div className=" mt-2 mb-2 Text-mb-Create">
                                  <label className="mb-1"> {t("User Profile.Institute logo")} </label>
                                  <input
                                    type="file"
                                    id="lastName"
                                    // className="form-control Dark-Input-from-group"
                                    placeholder=""
                                    onChange={handleFileChange}
                                  //   onChange={(e) => {
                                  //     handleProfileImageChange(e);
                                  //   }}
                                  //   invalid={displays && profileImage === ""}
                                  />
                                  {/* {displays && !profileImage ? (
                          <span className="error_msg_lbl text-red">
                            Upload Image{" "}
                          </span>
                        ) : null} */}
                                </div>
                                <div className="d-flex justify-content-end">
                                  <Button
                                    variant="primary"
                                    size="sm"
                                    onClick={handleSaveInstitution}
                                    className="me-2"
                                  >
                                    {t("Newsfeed.Save")}
                                  </Button>
                                  <Button
                                    variant="secondary"
                                    size="sm"
                                    onClick={() => {
                                      setShowTooltip(false);
                                      setOrganizationName("");
                                    }}
                                  >
                                    {t("Connections.Cancel")}
                                  </Button>
                                </div>
                              </Form>
                            </Popover.Body>
                          </Popover>
                        </Overlay>
                        {InsName !== "" ? (
                          <div className="d-flex align-items-center wlj-org-selected-row">
                            <input
                              type="text"
                              value={InsName}
                              placeholder={t("User Profile.Enter Company Name")}
                              className="mb-2 form-control"
                              disabled
                            />
                            <CloseSharpIcon
                              className="material-symbols-sharp pointer ms-2 mb-2"
                              onClick={handleCloseNewOrg}
                              title={t("User Profile.Close")}
                            />
                          </div>
                        ) : (
                          <Select
                            value={findSelectOption(optionsC, valueC)}
                            options={optionsC}
                            optionRenderer={renderOptionC}
                            placeholder={t("Newsfeed.Search and Select Company Name")}
                            onOpen={handleOpenC}
                            onChange={handleChangeC}
                            onMenuScrollToBottom={handleMenuScrollToBottomC}
                            onInputChange={handleInputChangeC}
                            isClearable
                            formatOptionLabel={(option) => (
                              <div>
                                {option.label}
                                {option.isOrgVrfd === true ? (
                                  <img src={resume.verified} width={15} className="ms-1" />
                                ) : option.isOrgRgd === true ? (
                                  <img src={resume.register} width={15} className="ms-1" />
                                ) : (
                                  <img src={resume.unregister} width={15} className="ms-1" />
                                )}
                              </div>
                            )}
                            className="iconsDropdown"
                            styles={customStyles} {...wljSelectPortalProps}
                            classNamePrefix="react-select"
                          />
                        )}
                      </div>
                      <div className="col-md-6 mt-2">
                        <label htmlFor="about">
                          {t("User Profile.Profile Headline")}
                        </label>
                        {showInputInsteadOfDropdown ? (
                          <input
                            type="text"
                            className="Dark-Input-from-group"
                            value={headline}
                            onChange={(e) => setHeadline(e.target.value)}
                            onBlur={() => {
                              if (headline.trim()) {
                                setShowInputInsteadOfDropdown(false);
                              }
                            }}
                            autoFocus
                            isInvalid={display && headline === ""}
                          />
                        ) : (
                          <CreatableSelect
                            options={optionsP}
                            styles={customStyles} {...wljSelectPortalProps}
                            classNamePrefix="react-select"
                            placeholder={t("User Profile.Select Field")}
                            noOptionsMessage={() => t("modals.Search and Select Field")}
                            onOpen={handleOpenProfle}
                            onChange={(selectedOption) => {
                              if (selectedOption) {
                                setHeadline(selectedOption.value);
                                setShowInputInsteadOfDropdown(true); // switch to editable input
                              } else {
                                setHeadline("");
                              }
                            }}
                            onMenuScrollToBottom={handleMenuScrollToBottomProfile}
                            onInputChange={handleInputChangeProfile}
                            isClearable
                            isValidNewOption={(inputValue, _, selectOptions) =>
                              !!inputValue && !selectOptions.some(option => option.label === inputValue)
                            }
                            onCreateOption={(inputValue) => {
                              const newOption = { label: inputValue, value: inputValue };
                              setOptionsP((prev) => [...prev, newOption]);
                              setHeadline(inputValue);
                              setShowInputInsteadOfDropdown(true); // switch to input after create
                            }}
                            value={headline ? { label: headline, value: headline } : null}
                            className={display && headline === "" ? "is-invalid" : ""}
                          />
                        )}
                        {/* <CreatableSelect
                                            // value={optionsP.find((option)=>option.value===headline)}
                                            options={optionsP}
                                            styles={customStyles} {...wljSelectPortalProps}
                                            optionRenderer={renderOption}
                                            placeholder={"Search and Select Profile Headline"}
                                            onOpen={handleOpenProfle}
                                            onChange={handleChangeProfile}
                                            onMenuScrollToBottom={handleMenuScrollToBottomProfile}
                                            onInputChange={handleInputChangeProfile}
                                            isClearable
                                             isValidNewOption={(inputValue, selectValue, selectOptions) =>
                                              !!inputValue && !selectOptions.some(option => option.label === inputValue)
                                            }
                                            onCreateOption={(inputValue) => {
                                              const newOption = { label: inputValue, value: inputValue };
                                              setOptionsP((prev) => [...prev, newOption]);
                                              setHeadline(inputValue); // directly set the value
                                            }}
                                            value={headline ? { label: headline, value: headline } : null}
                    
                                            invalid={display && headline === ""}
                                          /> */}
                      </div>
                      <div className="col-md-6 mt-2">
                        <label htmlFor="about">
                          {t("User Profile.City")}
                          <span className="text-danger ms-2">*</span>
                        </label>
                        <Select
                          value={findSelectOption(cityData, cityId)}
                          onChange={(selectedOption) =>
                            setCityId(selectedOption.value)
                          }
                          options={cityData}
                          placeholder={t("modals.Search and Select City")}
                          onInputChange={(inputValue) => {
                            setCitySearch(inputValue);
                          }}
                          styles={customStyles} {...wljSelectPortalProps}
                          classNamePrefix="react-select"
                        />
                      </div>

                      <div className="col-md-6 mt-2">
                        <label htmlFor="about">
                          {t("User Profile.Work Level Type")}
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <Select
                          value={workTypeData.find(
                            (options) => options.value === workTypeId
                          )}
                          onChange={(e) => {
                            setWorkTypeId(e.value);
                          }}
                          options={workTypeData}
                          styles={customStyles} {...wljSelectPortalProps}
                          classNamePrefix="react-select"
                          placeholder={t("Newsfeed.Select Work Level Type")}
                          isSearchable={false}
                        />
                      </div>
                      <div className="col-md-6 mt-2">
                        <label htmlFor="about">
                          {t("User Profile.Work Location Type")}
                          {" "}
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <Select
                          value={workLocationData.find(
                            (options) => options.value === workLocationId
                          )}
                          onChange={(e) => {
                            setWorkLocationId(e.value);
                          }}
                          options={workLocationData}
                          styles={customStyles} {...wljSelectPortalProps}
                          classNamePrefix="react-select"
                          placeholder={t("User Profile.Select Work Location Type")}
                          isSearchable={false}
                        />
                      </div>
                      <div className="col-md-6 mt-2">
                        <label htmlFor="about">
                          {t("User Profile.Employment type (Job Type)")} {" "}
                          <span style={{ color: "red" }}>*</span>
                        </label>

                        <Select
                          value={jobTypeData.find(
                            (options) => options.value === jobTypeId
                          )}
                          onChange={(e) => {
                            setJobTypeId(e.value);
                          }}
                          options={jobTypeData}
                          styles={customStyles} {...wljSelectPortalProps}
                          classNamePrefix="react-select"
                          placeholder={t("User Profile.Select Job Type")}
                          isSearchable={false}
                        />
                      </div>

                      <div className="col-md-6 mt-2">
                        <label htmlFor="about">
                          {t("User Profile.Description")}
                        </label>
                        <textarea
                          id="about"
                          name="about"
                          rows="2"
                          cols="50"
                          defaultValue={description}
                          onChange={(e) => setDescription(e.target.value)}
                        ></textarea>
                      </div>
                      {/* {checkCurrent === false || present === true ? */}
                      <div className="col-md-12 mt-2 d-flex align-items-center wlj-is-present-row">
                        <label htmlFor="about">
                          {t("User Profile.Is Present")}
                        </label>
                        <input
                          type="checkbox"
                          style={{ width: "20px", height: "20px", marginLeft: "5px" }}
                          //   id={`check-${item.id}`}
                          checked={present}
                          onChange={() => setPresent(!present)}
                        />
                      </div>
                      {/* : ''} */}

                      <div className="col-md-6 mt-2">
                        <label htmlFor="about">
                          {t("User Profile.Start Date")}
                          <span className="text-danger ms-2">*</span>
                        </label>

                        <Flatpickr
                          className="form-control"
                          value={startDate}
                          onChange={(date) => setStartDate(date[0] || null)}
                          id="dob"
                          options={{
                            maxDate: "today", // Disables future dates
                            appendTo: modalContentRef.current || undefined,
                            onReady: (selectedDates, dateStr, instance) => {
                              preventYearScroll(instance); // Call the function to stop scroll on year
                            },
                            onOpen: (selectedDates, dateStr, instance) => {
                              preventYearScroll(instance); // Also prevent scroll when the picker opens
                            },
                          }}
                        />

                        {display && !startDate ? (
                          <span className="error_msg_lbl">
                            {t("User Profile.Start Date")}
                          </span>
                        ) : null}
                      </div>

                      {!present && <div className="col-md-6 mt-2">
                        <label htmlFor="about">
                          {t("User Profile.End Date")}
                          <span className="text-danger ms-2">*</span>
                        </label>

                        <Flatpickr
                          className="form-control"
                          value={endDate}
                          onChange={(date) => setEndDate(date[0] || null)}
                          id="dob"
                          options={{
                            minDate: startDate || undefined,
                            appendTo: modalContentRef.current || undefined,
                            onReady: (selectedDates, dateStr, instance) => {
                              preventYearScroll(instance); // Call the function to stop scroll on year
                            },
                            onOpen: (selectedDates, dateStr, instance) => {
                              preventYearScroll(instance); // Also prevent scroll when the picker opens
                            },
                          }}
                        />
                        {!present && isExperienceDateRangeInvalid ? (
                          <span className="error_msg_lbl">
                            End date cannot be earlier than start date.
                          </span>
                        ) : null}
                      </div>}

                      <div className="col-md-12 text-end mt-4">
                        <div className="d-flex align-items-center justify-content-end">
                          {UserCcv === "Active" && <>
                            <input
                              type="checkbox"
                              style={{ width: "20px", height: "20px", marginRight: "5px" }}
                              onChange={() => setSync(!sync)}
                              checked={sync}
                            />
                            <label htmlFor="about">
                              {t("User Profile.Sync With Resume")}
                            </label>
                          </>}
                          <button
                            type="button"
                            className="closebtn me-2 ms-3"
                            onClick={handleUpdateExperienceClose}
                            style={{ width: "70px" }}
                          >
                            {t("User Profile.Close")}
                          </button>
                          <button
                            type="button"
                            className="mainBtn1"
                            onClick={UpdateExperience}
                            style={{ width: "107px" }}
                          >
                            {t("Manage Job.Update")}
                          </button>
                        </div>
                      </div>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
          </Portal>
        </div>
      )}

      <SuccessToast
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />

      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />

      <ErrorToast
        show={showErrorToast}
        message={ErrorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />
      {/* {showExperienceDelete && (
        <Portal layer="modal">
        <div
          className="modal fade show postAdd wlj-overlay-modal"
          tabIndex="-1"
          role="dialog"
          style={{ display: "flex" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6 className="wlj-modal-title--danger">
                  <DeleteOutlineSharpIcon className="material-symbols-sharp" />
                  Are You Sure You want to Delete Experience?
                </h6>
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    handleRemoveExperienceClose();
                  }}
                />
              </div>

              <div className="mt-2 text-center">
                <button
                  color=""
                  className="closebtn"
                  onClick={() => removeExperience()}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
        </Portal>
      )} */}
    </>
  );
};

export default ProfileExperienceUpdate;
